import { buttonVariants } from '@/components/shadcn/button'
import clsx from 'clsx'
import { IconV2DownloadOutline } from '@icons/IconV2DownloadOutline'
import { DmpChatAgentPicker } from './DmpChatAgentPicker'
import { DmpChatMockMenu } from './DmpChatMockMenu'
import { DmpChatToolDisplayMenu } from './DmpChatToolDisplayMenu'
import { useDmpChatRuntime } from './DmpChatRuntimeProvider'

export function DmpChatHeaderActions() {
  const {
    downloadSignalRTrace,
    isTurnActive,
    mockModeEnabled,
    mockScenario,
    setMockScenario,
    setToolDisplayMode,
    signalRTraceEnabled,
    signalRTraceMessageCount,
    toolDisplayMode,
  } = useDmpChatRuntime()

  return (
    <div className="flex flex-wrap items-center gap-2">
      <DmpChatAgentPicker />
      {mockModeEnabled && (
        <DmpChatMockMenu disabled={isTurnActive} onScenarioChange={setMockScenario} scenario={mockScenario} />
      )}
      {signalRTraceEnabled && (
        <button
          aria-label="Download captured DMP Chat SignalR messages"
          className={clsx(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-2')}
          disabled={signalRTraceMessageCount === 0}
          onClick={downloadSignalRTrace}
          type="button"
        >
          <IconV2DownloadOutline className="size-4" />
          <span>Download trace ({signalRTraceMessageCount})</span>
        </button>
      )}
      <DmpChatToolDisplayMenu mode={toolDisplayMode} onModeChange={setToolDisplayMode} />
    </div>
  )
}
